/**
 * FAQ Accordion Handler
 * Manages the expand/collapse behavior for FAQ cards on the state search results page.
 * Uses native HTML details/summary elements for accessibility and keyboard support.
 */

/**
 * Handles the toggle event for FAQ accordion items
 * @param {Event} e - The toggle event
 */
const handleFaqToggle = (e) => {
  const details = e.currentTarget;

  // Toggle the CSS class to match the open state
  details.classList.toggle('nhs-n1-c-card__faq-card--is-open', details.open);
};

const initializeFaqAccordion = () => {
  const faqCards = document.querySelectorAll('[data-faq-card]');

  faqCards.forEach((card) => {
    // Listen to the native 'toggle' event on details element
    card.addEventListener('toggle', handleFaqToggle);

    // Set initial state based on 'open' attribute
    if (card.open) {
      card.classList.add('nhs-n1-c-card__faq-card--is-open');
    }
  });
};

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeFaqAccordion);
} else {
  initializeFaqAccordion();
}

export default initializeFaqAccordion;
